import React from 'react';
import { Help } from 'react-bulma-components/lib/components/form';

export const Helptext = ({ children, color = null, ...props }) => (
  <Help color={color} {...props}>
    {children}
  </Help>
);

export default Helptext;
